import {
  BodyText,
  Box,
  Card,
  CardInteraction,
  IconButton,
} from '@utilitywarehouse/hearth-react';
import { AddSmallIcon } from '@utilitywarehouse/hearth-react-icons';

import { BrandLogo } from '@features/Cashback/Calculator/BrandLogo/BrandLogo';
import { RetailPartner } from '@generated/gql/graphql';

import './styles.scss';

interface BrandQuickAddItemProps {
  brand: RetailPartner;
  onClick: (brandId: RetailPartner['id']) => void;
}

const BrandQuickAddItem = ({ brand, onClick }: BrandQuickAddItemProps) => {
  return (
    <Card
      colorScheme="neutralStrong"
      variant="subtle"
      paddingNone
      alignItems="center"
      spacing="sm"
      className="brandQuickAdd__Item"
    >
      <BrandLogo brand={brand} />
      <Box flexGrow="1">
        <BodyText size="lg" weight="semibold">
          {brand.name}
        </BodyText>
      </Box>
      <CardInteraction>
        <IconButton
          type="button"
          label={`Add ${brand.name}`}
          variant="ghost"
          colorScheme="functional"
          size="sm"
          onClick={() => onClick(brand.id)}
        >
          <AddSmallIcon />
        </IconButton>
      </CardInteraction>
    </Card>
  );
};

export { BrandQuickAddItem, type BrandQuickAddItemProps };
